Vue.component('editor', {
    props: ['endpoint'],
    data() {
        return {
            model: null,
        }
    },
    methods: {
        loadModel() {
            axios.get(this.endpoint, {params: {ajax: true}})
                 .then(response => {
                    this.model = response.data;
                 });
        },
        save() {
            var method = 'patch';
            var endpoint = this.endpoint;

            if (this.model.endpoint) {
                endpoint = this.model.endpoint;
                method = 'post';
            }

            axios[method](endpoint, this.model)
                 .then(response => {
                    window.location = response.data;
                 });
        },
        confirmDelete(model, row, attribute) {
            this.$swal({
              title: 'Are you sure?',
              text: "Deleting this item can not be undone",
              icon: 'warning',
              showCancelButton: true,
              confirmButtonColor: '#d33',
              cancelButtonColor: '#3085d6',
              confirmButtonText: 'Yes, delete it!'
            }).then((result) => {
                if (result.value) {
                    axios.delete(model.detail_uri)
                         .then(response => {
                            this.model[attribute].splice(row, 1);
                         });
                }
            });
        }
    },
    mounted() {
        this.loadModel();

        this.eventHub.$on('downloadAdded', download => {
            this.model.downloads.push(download);
        });
    }
});